import React from 'react';
import classnames from 'classnames';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DataProduct } from 'v2/models';
import angleIcon from 'v2/icons/angle.svg';
import styles from './dataSetsList.module.scss';
import { useTranslation } from 'react-i18next';
import { TranslationKeys, PostProcessKeys } from 'translations';

interface DataSetsListProps {
  list: DataProduct[] | undefined;
}

const DataSetsList = ({ list }: DataSetsListProps) => {
  const { t } = useTranslation();

  const renderDataSetsList = () => {
    return (
      <>
        {list?.map((item, index) => (
          <Link
            key={item.id}
            className="text-decoration-none"
            data-cy={`dataset:item-${index}`}
            data-description={item.description}
            role="listitem"
            to={{
              pathname: `/data-set-details/${item.id}/detail`,
              state: {
                backLinkTitle: t(TranslationKeys.dataProduct_other, {
                  postProcess: PostProcessKeys.TitleCase,
                }),
              },
            }}
          >
            <Card className="mb-3">
              <Card.Body className={classnames(styles.rowBody)}>
                <div
                  className={classnames(styles.tableRow, styles.columnStyle)}
                >
                  <div className="d-flex">
                    <p
                      className={classnames(
                        'text-truncate pr-1 text-dark',
                        'd-flex align-items-center',
                        styles.lineHeight,
                        styles.itemName
                      )}
                    >
                      <>{item.name}</>
                    </p>
                  </div>
                  <p
                    className={classnames(
                      'text-truncate pr-1 text-dark pl-1',
                      'd-flex align-items-center',
                      styles.lineHeight
                    )}
                  >
                    <>{item?.data_vendor?.name || ''}</>
                  </p>
                  <p
                    className={classnames(
                      'text-truncate pr-1 text-dark pl-1',
                      'd-flex align-items-center',
                      styles.lineHeight
                    )}
                  >
                    <>{item?.data_vendor?.classification || ''}</>
                  </p>
                </div>
                <div className={classnames(styles.nextLink)}>
                  <img src={angleIcon} alt="angleIcon"></img>
                </div>
              </Card.Body>
            </Card>
          </Link>
        ))}
      </>
    );
  };

  return (
    <div className={classnames('position-relative', styles.tableContainer)}>
      <div>
        <div className={classnames(styles.tableHeader, styles.columnStyle)}>
          <p className={classnames('no-wraping-text pr-1 pl-1')}>
            {t(TranslationKeys.dataProduct_one, {
              postProcess: PostProcessKeys.TitleCase,
            })}{' '}
            Name
          </p>
          <p className={classnames('no-wraping-text pr-1 pl-1')}>
            {t(TranslationKeys.company_one, {
              postProcess: PostProcessKeys.TitleCase,
            })}
          </p>
          <p className={classnames('no-wraping-text pr-1 pl-1')}>
            {t(TranslationKeys.data_one, {
              postProcess: PostProcessKeys.TitleCase,
            })}{' '}
            Type
          </p>
        </div>
        {!list?.length && (
          <div className={styles.NoDataContent}>
            <hr></hr>
            <h1>No datasets have been added yet!</h1>
          </div>
        )}
        {renderDataSetsList()}
      </div>
    </div>
  );
};

export default DataSetsList;
